import api from '../../api/axios';

// Action Types
export const GET_KNOWLEDGE_BASE_REQUEST = 'GET_KNOWLEDGE_BASE_REQUEST';
export const GET_KNOWLEDGE_BASE_SUCCESS = 'GET_KNOWLEDGE_BASE_SUCCESS';
export const GET_KNOWLEDGE_BASE_FAILURE = 'GET_KNOWLEDGE_BASE_FAILURE';

export const ADD_KNOWLEDGE_BASE_REQUEST = 'ADD_KNOWLEDGE_BASE_REQUEST';
export const ADD_KNOWLEDGE_BASE_SUCCESS = 'ADD_KNOWLEDGE_BASE_SUCCESS';
export const ADD_KNOWLEDGE_BASE_FAILURE = 'ADD_KNOWLEDGE_BASE_FAILURE';

export const CREATE_DOCUMENT_REQUEST = 'CREATE_DOCUMENT_REQUEST';
export const CREATE_DOCUMENT_SUCCESS = 'CREATE_DOCUMENT_SUCCESS';
export const CREATE_DOCUMENT_FAILURE = 'CREATE_DOCUMENT_FAILURE';

export const UPLOAD_DOCUMENT_REQUEST = 'UPLOAD_DOCUMENT_REQUEST';
export const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';
export const UPLOAD_DOCUMENT_FAILURE = 'UPLOAD_DOCUMENT_FAILURE';

export const DELETE_KNOWLEDGE_BASE_REQUEST = 'DELETE_KNOWLEDGE_BASE_REQUEST';
export const DELETE_KNOWLEDGE_BASE_SUCCESS = 'DELETE_KNOWLEDGE_BASE_SUCCESS';
export const DELETE_KNOWLEDGE_BASE_FAILURE = 'DELETE_KNOWLEDGE_BASE_FAILURE';

export const GET_KNOWLEDGE_BASE_BY_ID_REQUEST = 'GET_KNOWLEDGE_BASE_BY_ID_REQUEST';
export const GET_KNOWLEDGE_BASE_BY_ID_SUCCESS = 'GET_KNOWLEDGE_BASE_BY_ID_SUCCESS';
export const GET_KNOWLEDGE_BASE_BY_ID_FAILURE = 'GET_KNOWLEDGE_BASE_BY_ID_FAILURE';

export const RESET_SELECTED_KNOWLEDGE_BASE = 'RESET_SELECTED_KNOWLEDGE_BASE';

// Get Knowledge Base Action
export const getKnowledgeBase = () => async (dispatch) => {
  try {
    dispatch({ type: GET_KNOWLEDGE_BASE_REQUEST });
    const response = await api.get(`knowledge-base`);
    const data = response?.data || {};
    dispatch({ type: GET_KNOWLEDGE_BASE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'Failed to fetch knowledge base data';
    dispatch({ type: GET_KNOWLEDGE_BASE_FAILURE, error: errorMessage });
    throw error;
  }
};

// Add Knowledge Base Action
export const addKnowledgeBase = (knowledgeData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_KNOWLEDGE_BASE_REQUEST });
    const response = await api.post('knowledge-base/create', knowledgeData);
    const data = response?.data || {};
    dispatch({ type: ADD_KNOWLEDGE_BASE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'Failed to add knowledge base';
    dispatch({ type: ADD_KNOWLEDGE_BASE_FAILURE, error: errorMessage });
    throw error;
  }
};

// Create Document Action
export const createDocument = (documentData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_DOCUMENT_REQUEST });
    const response = await api.post('knowledge-base/createDocument', documentData);
    const data = response?.data || {};
    dispatch({ type: CREATE_DOCUMENT_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'Failed to create document';
    dispatch({ type: CREATE_DOCUMENT_FAILURE, error: errorMessage });
    throw error;
  }
};

// Upload Document File
export const uploadDocumentFile = (documentFileData) => async (dispatch) => {
  try {
    dispatch({ type: UPLOAD_DOCUMENT_REQUEST });
    const response = await api.post('knowledge-base/createDocumentFile', documentFileData);
    const data = response?.data || {};
    dispatch({ type: UPLOAD_DOCUMENT_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'Failed to create document';
    dispatch({ type: UPLOAD_DOCUMENT_FAILURE, error: errorMessage });
    throw error;
  }
};

// Delete Knowledge Base Action
export const deleteKnowledgeBase = (knowledgeBaseId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_KNOWLEDGE_BASE_REQUEST });
    const response = await api.delete(`knowledge-base/${knowledgeBaseId}`);
    const data = response?.data || {};
    dispatch({ type: DELETE_KNOWLEDGE_BASE_SUCCESS, payload: { id: knowledgeBaseId, data } });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'Failed to delete knowledge base';
    dispatch({ type: DELETE_KNOWLEDGE_BASE_FAILURE, error: errorMessage });
    throw error;
  }
};

// Get Knowledge Base By ID Action
export const getKnowledgeBaseById = (knowledgeBaseId) => async (dispatch) => {
  try {
    dispatch({ type: GET_KNOWLEDGE_BASE_BY_ID_REQUEST });
    const response = await api.get(`knowledge-base/${knowledgeBaseId}`);
    const data = response?.data || {};
    dispatch({ type: GET_KNOWLEDGE_BASE_BY_ID_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'Failed to fetch knowledge base details';
    dispatch({ type: GET_KNOWLEDGE_BASE_BY_ID_FAILURE, error: errorMessage });
    throw error;
  }
};

// Reset Selected Knowledge Base Action
export const resetSelectedKnowledgeBase = () => (dispatch) => {
  dispatch({ type: RESET_SELECTED_KNOWLEDGE_BASE });
};
